<div class="event-header" (click)="toggle()">
    @if (couponHeader) {
        @if (isOptionsExist) {
            <div class="event-toggle">
                @if (isExpanded) {
                    <vn-icon name="theme-up" size="16" />
                } @else {
                    <vn-icon name="theme-down" size="16" />
                }
            </div>
        }
    } @else {
        <ng-container *ngTemplateOutlet="eventToggle; context: { isShowInEpcot: false }" />
    }
    @if (isEventNameALink || isLeagueChildPageDesign) {
        <a class="event-info" [href]="eventUrl" (click)="navigate($event)">
            <ng-container *ngTemplateOutlet="eventHeader" />
        </a>
    } @else {
        <a class="event-info">
            <ng-container *ngTemplateOutlet="eventHeader" />
        </a>
    }
    @if (!isLeagueChildPageDesign && isAllBetsButtonVisible) {
        <!-- TODO Buttons Design System - change this to use [href]="eventUrl" again when vanilla changes plain-link component to a directive -->
        <a
            ds-button
            plain-link
            msThemedButton
            kind="tertiary"
            variant="outline"
            size="small"
            truncate="true"
            class="all-bets-button"
            [themeVariant]="buttonThemeVariant"
            (click)="navigate($event)">
            {{ sitecore.event.Markets }}
            <vn-icon slot="end" name="theme-right" size="11" />
        </a>
    }
    @if (!couponHeader) {
        @if (media.enabled) {
            <ms-event-media [event]="event" [media]="media" [isEventHovered]="isEventHovered()" [tracking]="tracking" />
        }
        <ng-container *ngTemplateOutlet="eventToggle; context: { isShowInEpcot: true }" />
    }
</div>

<ng-template #eventToggle let-isShowInEpcot="isShowInEpcot">
    <div *msShowInEpcot="isShowInEpcot" [ngClass]="isLeagueChildPageDesign ? 'league-childpage-event-toggle' : 'event-toggle'">
        @if (state?.collapsed) {
            <vn-icon name="theme-down" size="16" />
        } @else {
            <span class="toggle-icon-alignment"><vn-icon name="theme-up" size="16" /></span>
        }
    </div>
</ng-template>

<ng-template #eventHeader>
    @if (isLeagueChildPageDesign) {
        <div class="event-container">
            <div class="event-name">
                {{ eventTitle }}
            </div>
            <div class="event-end-toggle">
                <vn-icon name="theme-right" size="16" />
            </div>
        </div>
    } @else {
        <div class="event-name">{{ eventTitle }}</div>
    }
    <ms-event-info
        [disableBadges]="isLeagueChildPageDesign && !isOutrightMarket"
        [event]="event"
        [isOutrightMarket]="isOutrightMarket"
        [mediaEnabled]="media.enabled"
        [hideFavouriteIcon]="true" />
</ng-template>
